<div class="navbar-top">

  <div class="logo">
    <img class="logo-icon" [src]="_cdkConfigService.icone" alt="Logo do sistema" aria-hidden="true">
    <span class="logo-text text-secondary">{{_cdkConfigService.sigla}}</span>
  </div>

  <div class="buttons">

    <button mat-icon-button class="toggle-sidebar-folded lt-lg:hidden"
      (click)="toggleSidebarFolded()" aria-label="Recolher menu lateral">
      <mat-icon class="text-secondary">menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened lg:hidden"
      (click)="toggleSidebarOpened()" aria-label="Fechar menu lateral">
      <mat-icon class="text-secondary">arrow_back</mat-icon>
    </button>

  </div>

</div>


<div class="navbar-scroll-container"
  cdkScrollbar [cdkScrollbarOptions]="{wheelPropagation: false ,suppressScrollX: false}">

  <div class="navbar-content">
    <cdk-navigation class="material2" layout="vertical"></cdk-navigation>
  </div>

</div>
@if(!currentlyUnfolded()) {
  <div
    class="navbar-bottom-container bg-[var(--cdk-bg-default)] flex justify-center items-end flex-auto cursor-pointer pb-3"
    (pointerover)="$event.stopPropagation()"
    (pointerout)="$event.stopPropagation()"
    (click)="changeFoldedAutoTriggerOnHover()"
    (mouseleave)="onMouseLeaveLockArea()"
  >
    @let lockedFoldedValue = lockedFolded();
    <button mat-icon-button aria-label="Ativar ou desativar menu lateral ao passar o mouse"
      [matTooltip]="(lockedFoldedValue ? 'Ativar' : 'Desativar') + ' menu lateral ao passar o mouse'"
      [class.bg-primary]="lockedFoldedValue">
      <mat-icon [class.text-on-primary]="lockedFoldedValue">
        menu_open
      </mat-icon>
    </button>
  </div>
}
